export enum FlowType {
    DEFAULT = 'DEFAULT',
    TPAY = 'TPAY',
    SBERPAY = 'SBERPAY',
    ALFAPAY = 'ALFAPAY',
    VTBPAY = 'VTBPAY',
    NSPK = 'NSPK',
    GPBPAY = 'GPBPAY',
    PSBPAY = 'PSBPAY',
}